<template>
    <v-dialog v-model="dialog" max-width="500px" persistent  @keydown.esc="closeModal(false)">
        <v-card>
            <v-container>
                <div class="modal__container__div--Btn">
                    <v-btn class="modal__container__btn__close" text @click="closeModal(false)">
                        <span class="modal__container__btn__close--span" :style="{'color': currentCompany.buttonsColor }" > x </span>                    
                    </v-btn>
                </div>
                <v-card-title class="flex-row-center no-pd-t no-pd-l no-pd-r vdialog_container_cardtile__title"> {{instructionObject.title}} </v-card-title>
                <v-card-text class="no-pd">
                    <v-row class="flex-col-center">                      
                        <span class="vdialog_container_cardtext__value">{{instructionObject.value}}</span>                                         
                        <span class="vdialog_container_cardtext__pointsRendeem">{{instructionObject.pointsToRedeem}}</span>                        
                    </v-row>

                    <v-divider/>

                    <v-row class="flex-col-center">                     
                        <span id="color__darkblue" class="vdialog_container_cardtext__instructiontitle">Para resgatar, siga as instruções:</span>
                        <span class="vdialog_container_cardtext__instructions"><strong id="color__darkblue">1. </strong>Leve seus produtos até o caixa;</span>
                        <span class="vdialog_container_cardtext__instructions"><strong id="color__darkblue">2. </strong>Se idenfique no caixa através do seu CPF;</span>
                        <span class="vdialog_container_cardtext__instructions"><strong id="color__darkblue">3. </strong>Solicite o resgate ao atendente;</span>
                        <!-- <span>{{ 'Expira em ' + instructionObject.expires + (instructionObject.expires == 1 ? ' dia' : ' dias') }}</span> -->
                    </v-row>
                </v-card-text>
            </v-container>                           
        </v-card>
    </v-dialog>
</template>

<script>
//Store
import { mapGetters } from "vuex";

export default {
    name: 'RescueInstruction',
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        voucherObject: {
            type: Object
        }
    },
     computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        ),
    },
    data: () => ({
        instructionObject: {
            expires: 2
        }
    }),
    watch: {
        voucherObject:{
            deep: true,
            immediate: true,
            handler() {
                this.setInfoModal(this.voucherObject)
            }            
        }
    },
    methods: {
        closeModal(condition) {
            this.$emit('rescueInstructionModalClose', condition)
        },
        setInfoModal(param) {
            var condition = param.discountPercent == null && param.discountValue == null
            switch(condition) {
                case true: {
                    this.instructionObject.title = 'Produto'
                    this.setValuesAndFormat(param)
                    break;
                }
                case false: {
                    this.instructionObject.title = 'Vale compras'
                    this.setValuesAndFormat(param)
                    break;
                }
                default: {
                    break;
                }
            }
        },
        setValuesAndFormat(value) {
            var stringDynamic = value.pointsToRedeem  <= 1 ? ' ponto' : ' pontos'
            this.instructionObject.pointsToRedeem = 'Custo: ' + value.pointsToRedeem + stringDynamic

            if( value.discountPercent == null && value.discountValue == null ) { //Produto
                this.instructionObject.value = value.name
            }
            if( value.discountPercent !== null && value.discountValue == null ) { //Vale compras
                this.instructionObject.value = value.discountPercent + '%'
            }
            if( value.discountValue !== null && value.discountPercent == null ) { //Vale compras            
                var stringDiscountValue = value.discountValue.toString() 
                stringDiscountValue.indexOf('.') == -1 ? this.instructionObject.value = 'R$' + value.discountValue + '.00' : this.instructionObject.value = 'R$' + value.discountValue + '0'
            }
        },

    }
}
</script>

<style scoped>
::v-deep .v-dialog {
    border-radius: 12px;
}
#color__darkblue {
    color: var(--cor--azul--escuro) !important;
}
.vdialog_container_cardtile__title {
    color: var(--cor--preta);
    font-weight: 600;
    font-size: 20px;
}
.vdialog_container_cardtext__value {
    color: var(--cor--verde);
    font-weight: bold;
    font-size: 20px;
    padding-bottom: 8px;
}
.vdialog_container_cardtext__pointsRendeem {
    color: var(--cor--cinza--escuro);
    font-weight: 300;
    font-size: 16px;
    padding-bottom: 6px;
}
.vdialog_container_cardtext__instructiontitle {
    font-weight: bold;
    font-size: 14px;
    padding: 6px 0px 10px 0px
}
.vdialog_container_cardtext__instructions{
    font-weight: 400;
    color: var(--cor--cinza--escuro);
}
</style>